import { SITE, testimonials } from "../data";

export default function BrandSection() {
  return (
    <section id="brand" className="bg-accent-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr,1.4fr] gap-10 lg:gap-16 items-start">
          <div>
            <span className="inline-flex items-center gap-2 text-[11px] font-label tracking-[0.2em] uppercase text-accent-800 mb-3">
              <span className="w-6 h-px bg-accent-600" />
              About us
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-black leading-tight text-foreground-950">
              关于{SITE.brand}
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              {SITE.brand}由一群长期做内容评审的人发起。我们看到太多人说错一句话就被放大、
              被挂上热搜，却很少有一个地方，能让人主动调侃自己、并因此获得掌声。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              于是我们定下了三条内容原则：真实优先、只讲自己、拒绝攻击。
              赛事鼓励的从来不是揭短，而是那种敢于承认「我也干过蠢事」的坦率。
            </p>
            <dl className="mt-7 grid grid-cols-3 gap-4">
              <div>
                <dt className="text-xs text-foreground-500">内容原则</dt>
                <dd className="mt-1 font-heading text-sm font-bold text-foreground-950">真实 · 自嘲 · 友善</dd>
              </div>
              <div>
                <dt className="text-xs text-foreground-500">举办频率</dt>
                <dd className="mt-1 font-heading text-sm font-bold text-foreground-950">每年两季</dd>
              </div>
              <div>
                <dt className="text-xs text-foreground-500">评审规模</dt>
                <dd className="mt-1 font-heading text-sm font-bold text-foreground-950">48 位评委</dd>
              </div>
            </dl>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {testimonials.map((item) => (
              <blockquote
                key={item.name}
                className="p-5 md:p-6 rounded-lg bg-background-50 border border-accent-200 flex flex-col"
              >
                <i className="ri-double-quotes-l text-2xl text-accent-500" aria-hidden="true"></i>
                <p className="mt-3 text-sm text-foreground-700 leading-relaxed flex-1">{item.quote}</p>
                <footer className="mt-4 pt-4 border-t border-background-200 flex items-center gap-3">
                  <span className="w-9 h-9 rounded-full bg-secondary-100 text-secondary-800 flex items-center justify-center text-sm font-bold">
                    {item.name.slice(0, 1)}
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-950">{item.name}</p>
                    <p className="text-xs text-foreground-500">{item.role}</p>
                  </div>
                </footer>
              </blockquote>
            ))}
            <div className="p-5 md:p-6 rounded-lg bg-foreground-950 text-background-100 flex flex-col justify-center">
              <p className="font-heading text-lg font-bold text-background-50">你的故事也值得被鼓掌</p>
              <p className="mt-2 text-sm text-background-300 leading-relaxed">
                把它写下来，交给这个赛季。也许下一个被精选的，就是你。
              </p>
              <a
                href="#play"
                className="mt-4 inline-flex items-center gap-2 px-5 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap self-start transition-colors"
              >
                <i className="ri-play-circle-line" aria-hidden="true"></i>
                了解参赛流程
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}